import * as React from 'react';
import { withRouter, RouteComponentProps, Link } from 'react-router-dom'
import { Col, Row, Button, Radio, Icon, Spin, Tabs, Card } from 'antd';
import { withTranslation, WithTranslation } from 'react-i18next'
import { withIdentity, IdentityProps } from 'src/core/services/authentication';
import ContentTitle from 'src/core/ui/content-header';
import WhatsNewTabView from './whats-new/whats-new-tab'
import { navigate } from '../../../core/ui/link';
import {UserProfileProps, withUserProfile} from "../../../components/user-profile";

interface WhatsNewReportViewProps extends RouteComponentProps, WithTranslation, UserProfileProps {

}

interface WhatsNewReportViewState {
}

class AppSettingsView extends React.Component<WhatsNewReportViewProps, WhatsNewReportViewState> {
    constructor(props: WhatsNewReportViewProps) {
        super(props);
        this.state = {
            isBusy: false,
        }
    }

    private checkAuthAdmin() {
        return this.props.userProfile && this.props.userProfile.roles && (this.props.userProfile.roles.includes("Administrator") || this.props.userProfile.roles.includes("FIConsultant") || this.props.userProfile.roles.includes("ClientAdmin"))
    }

    private checkAuthAdminFi() {
        return this.props.userProfile && this.props.userProfile.roles && (this.props.userProfile.roles.includes("FIConsultant"))
    }

    componentWillMount() {
        if (!this.checkAuthAdmin())
            this.props.history.push('/');
    }

    componentWillUpdate() {
        if (!this.checkAuthAdmin())
            this.props.history.push('/');
    }
    public render() {
        const { t } = this.props;
        return <div>
            <Row gutter={0}>
                <Col span={10}>
                    <ContentTitle title={t("Application Settings")} />
                </Col>
                <Col span={50} style={{ marginTop: 40 }}>
                    <Radio.Group style={{ float: 'right' }} value="app-settings">
                        <Radio.Button value="companies-settings" onClick={() => navigate(this.props.history, `/time-tracking/admin/`)}>{t('Companies Settings')}</Radio.Button>
                        {this.checkAuthAdminFi() && <Radio.Button value="app-settings">{t('Application Settings')}</Radio.Button>}
                       
                    </Radio.Group>
                </Col>
            </Row>
            <Card style={{ width: '100%', zIndex: 0, marginTop: 8 }}>
                <Tabs tabPosition={"top"}>
                    <Tabs.TabPane key="en" tab={t("What's New")}>
                        <WhatsNewTabView />
                    </Tabs.TabPane>
                </Tabs>
            </Card>
        </div>
    }
}
export default withUserProfile(withIdentity(withRouter(withTranslation()(AppSettingsView as any) as any) as any)) as any
